import React, { Component } from "react";
import { SubMenuLink } from "./SubMenuLink";
import { DashboardIcon } from "../../Common/Icons";

export default class CollaboratorSpaceLink extends Component {
  render() {
    return (
      <SubMenuLink pathname={"/collaborator-space"} title={"myDashboard"}>
        <DashboardIcon className={"light-sub-menu-icon"} />
      </SubMenuLink>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/CollaboratorSpaceLink.js